<template>
  <div>
    <el-row>
      <el-form>
        <div style="float: left; margin: 5px">

          <el-tag style="margin-left:4px" @close="removeSelected(i)" closable v-for="(m, i) in selectedMeasurements"
            v-bind:key="i">
            <el-link type="primary" target="_blank" :href="`/measurement/${m._id}`" icon="el-icon-top-right">
              {{ m.createdAt }}
            </el-link>
          </el-tag>
        </div>
        <el-form-item size="mini" :label="''" style="float: right; margin: 5px">
          <el-button icon="el-icon-download" @click="downloadCsv">
            csv
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <div id="plotly" style="height: 420px" ref="plotly"></div>
    </el-row>
    <el-dialog width="80%" title="Comparison" :visible.sync="showCompare">
      <CompareMeasurement v-if="showCompare && selectedMeasurements.length"
        :measurementIds="selectedMeasurements.map(x => x._id)" :axis="compareAxis"></CompareMeasurement>
    </el-dialog>
    <div ref="commentPopup" class="commentPopup" style="padding: 10px;
        font-size: 10px;
        position: absolute;
        background-color: white;
        border-radius: 1;
        box-shadow: 5px 5px 8px #00000075;
        z-index: 999;
        left: 404px;
        max-width: 100px;
        max-height: 100px;
        width: 100px;
        height: 60px;
        top: 100px;
        font-style: italic;
        display: none;
        word-break: break-all;
      "></div>
  </div>

</template>

<script>
import Plotly from "./Plotly";
import dayjs from "dayjs-ext";
import { mapState, mapActions } from "vuex";
import { treeHelper } from "../util";
import preferences from "../util/preferences";
import CompareMeasurement from './CompareMeasurement.vue';
export default {
  name: "TrendChart",
  components: {
    CompareMeasurement
  },
  props: {
    telemetries: {
      type: Array,
      required: true,
      default: () => []
    },
    trend: {
      type: Object,
    },
    showComments: {
      type: Boolean,
      default: true,
    },
    dateRange: {
      type: Array,
    },
    colorSet: {
      type: Array,
    },
    mode: {
      type: String,
    },
    hideGoTo: {
      type: Boolean,
      default: false,
    },
    // predictionClassColor: {
    //   type: Array,
    //   default: [
    //     "#eb2359",
    //     "#2326eb",
    //     "#27e834",
    //     "#f0e32b",
    //     "#f0a82b",
    //     "#e630e2",
    //     "#30e6d3",
    //   ],
    // },
    multiSource: {
      type: Boolean,
      default: false,
    },
    markerSet: {
      type: Array,
      default: ["circle", "diamond", "star-triangle-up", "star"],
    },
    predictions: {
      type: Array,
      default: [],
    },
  },
  events: ["goMeasurement"],
  computed: {
    compareAxis() {
      if (this.trend && this.trend.trend && this.trend.trend.length) {
        let a = this.trend.trend[0].data[0].source;
        if (a.endsWith("accelerometer_x")) {
          return "accelerometer_x";
        }
        else if (a.endsWith("accelerometer_y")) {
          return "accelerometer_y";
        }
        else if (a.endsWith("accelerometer_z")) {
          return "accelerometer_z";
        }
      }
      return "accelerometer_x";
    },
    compareEnabled() {

      if (this.selectedMeasurements.length == 2 && this.trend.trend.length == 1 && ["GRMS", "VRMS", "VRMS_ISO10816"].includes(this.trend.trend[0].telemetry.name)) {
        return true;
      } else {
        return false;
      }
    },

    ...mapState("trend", ["trendCache", "activeData"]),
    ...mapState("tree", ["flatTree"]),
    min() {
      return Math.min(this.trend.trend.y);
    },
    max() {
      return Math.max(this.trend.trend.y);
    },
    path: function () {
      if (this.trend.trend.point) {
        const regex = / > /gi;
        let pathName = treeHelper.pointIdToPath(this.flatTree, this.trend.trend.point);
        pathName = pathName.replace(regex, "_");
        return pathName;
      } else return "";
    },
  },
  created() {
  },
  mounted() {
    let self = this;
    try {
      new ResizeObserver(function () {
        Plotly.Plots.resize();
      }).observe(this.$refs.plotly);
    } catch (e) {

    }

    this.init();
  },

  data() {
    return {
      selectedMeasurements: [],
      series: [],
      options: {
        displayLogo: false,
      },
      showCompare: false,
      layout: {
        height: 420,
        margin: {
          l: 10,
          r: 10,
          b: 30,
          t: 0,
          pad: 0,
        },
        showlegend: false,
        xaxis: {
          automargin: true,
          title: this.$t("measurement.date"),
          showticklabels: true,
          exponentformat: "e",
          showexponent: "all",
          //  nticks:5,
          tickformat: "%d-%m-%Y<br>%H:%M:%S",
        },

        modebar: {
          orientation: "h",
        },
        displayLogo: false,
      },
    };
  },
  watch: {
    predictions: function () {
      this.init();
    },
    mode: function () {
      this.init();
    },
    showComments: function () {
      this.init();
    },
    "trend.trend": function () {
      // console.log(this.trend.trend)
      // this.layout.yaxis.title = this.trend.trend.unit[0];
      this.init();
    },
    trend: function () {
      this.init();
    },
  },
  methods: {
    ...mapActions("trend", ["updateActiveData"]),
    sourceCount(telemetry) {
      let t = this.telemetries.find(x => x.telemetry.name == telemetry);
      if (!t) {
        return 0;
      }
      return t.telemetrySources.length;
    },
    downloadCsv() {
      let N = this.$refs.plotly.data.length;
      let sliced = this.$refs.plotly.data.slice(1, N);
      let columns = sliced.map((x) => x.name);
      let header = ["time", columns, "measurement"].join(",");

      let rows = this.trend.trend[0].data
        .map((a, i) => {
          let cols = this.trend.trend.map((t) => t.data[i].value);
          let time = this.trend.trend[0].data[i].createdAt;
          let measurement = `${window.location.origin}/measurement/${this.trend.trend[0].data[i].measurement}`;
          let row = [time, ...cols, measurement];
          return row.join(",");
        })
        .join("\n");

      let body = [header, rows].join("\r\n");
      let csvContent = "data:text/csv;charset=utf-8," + body;

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${dayjs().format()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    onDataPointClicked(data) {

      let measurement = this.trend.trend[0].data[data.points[0].pointIndex];
      let m = {
        _id: measurement.measurement,
        x: data.points[0].x,
        y: data.points[0].y,
        createdAt: dayjs(measurement.createdAt).format(
          preferences().localization.dateFormat
        ),
        date: dayjs(measurement.createdAt).toDate(),
      };


      this.$emit("goMeasurement", m._id);
      this.selectedMeasurements = [m];


      this.renderSelectedMeasurements();
    },
    removeSelected(i) {
      this.selectedMeasurements.splice(i, 1);
      this.renderSelectedMeasurements();
    },
    renderSelectedMeasurements() {
      // todo add max number of invsible and update values
      let shapes = JSON.parse(JSON.stringify(this.shapes));
      for (let i = 0; i < this.selectedMeasurements.length; i++) {
        let m = this.selectedMeasurements[i];
        shapes.push({
          "type": "line",
          "x0": m.x,
          "y0": 0,
          "x1": m.x,
          "yref": "paper",
          "y1": 1,
          "line": {
            "color": "rgba(0, 0, 0, 0.5)",
            "width": 1,
            "dash": "dot"
          },
          "visible": true,
        });
      }

      Plotly.relayout(this.$refs.plotly, { shapes });
    },

    animate(duration, fps) {
      fps = fps || 500;
      let plotlyElemet = this.$refs.plotly;
      let layout = plotlyElemet.layout;
      let datas = plotlyElemet.data;

      let series = JSON.parse(JSON.stringify(this.series));


      series.forEach((s, i) => {
        s["x"] = [];
        s["y"] = [];
      });
      series[0] = {};

      Plotly.newPlot(plotlyElemet, series, layout, { responsive: true });

      let animationSpeed = duration * 1000;
      let batchSize = Math.ceil(datas[1].y.length / (animationSpeed / fps));

      //clear chart
      let indices = series.map((x, i) => i);
      indices.splice(0, 1);

      let interval = setInterval(function () {
        let batchX = [];
        let batchY = [];
        for (let i = 1; i < series.length; i++) {

          let subX = datas[i].x.splice(0, batchSize);
          let subY = datas[i].y.splice(0, batchSize);
          batchX.push(subX);
          batchY.push(subY);
        }

        let update = {
          x: batchX,
          y: batchY,
        };

        Plotly.extendTraces(plotlyElemet, update, indices);

      }, fps);

      setTimeout(() => {
        clearInterval(interval);
      }, animationSpeed * 2);
    },
    init() {



      let layoutCopy = JSON.parse(JSON.stringify(this.layout));
      layoutCopy.colorway = [
        "#f3cec9",
        "#e7a4b6",
        "#cd7eaf",
        "#a262a9",
        "#6f4d96",
        "#3d3b72",
        "#182844",
      ];



      layoutCopy["yaxis"] = {
        automargin: true,
        title: "invisible",
        visible: false,
        //  overlaying: 'y',
      };
      this.selectedMeasurements = [];
      const groupedTrends = _.groupBy(this.trend.trend, x => x.telemetry.unit)

      let N = this.trend.trend.length;
      if (N > 2) {
        let pad = (N / 2) * 0.05;
        layoutCopy.xaxis.domain = [pad, 1 - pad];
      }
      let trendCount = 0;

      Object.values(groupedTrends).forEach((x, index) => {

        const groupedName = []
        let position = index % 2 == 0 ? 0 : 1;
        let side = index % 2 == 0 ? "left" : "right";

        
        const dataRange = [...x.map(x => x.data.map((c) => c.value)).flat()]
     
        const min = Math.min(...dataRange)
        const max = Math.max(...dataRange)
        let range = [(min), (max)]
        if (max < min) { range = [(max), (min)] }
-
        console.log(range, 'test')
        for (let i = 0; i < x.length; i++) {
          let t = x[i];
          let sample = t.data[0];
          const axisIndex = this.trend.trend.findIndex((x) => { if (x.telemetry.name == t.telemetry.name && x.data[0].source == sample.source) { return x } })
          trendCount = axisIndex

          let title = this.$t('duck.' + t.telemetry.name);

          if (this.sourceCount(t.telemetry.name) > 1) {
            title = this.$t(`duck.${t.telemetry.name}`) + " (" + this.$t('duck.' + sample.source) + ")";
          }
          
          layoutCopy["yaxis" + (trendCount + 2)] = {
            automargin: true,
            title: null,
            titlefont: { size: 15 },
            title_standoff: 0,
            range: range,
            overlaying: "y",
            rangemode: 'tozero',
            position: position,
            side: side,
            visible: false
          };

          title = title + ' ' + t.telemetry.unit;
          groupedName.push(title)

        }

        if (index > 1) {
          position = position + (((index % 2 == 0 ? 1 : -1) * 0.03 * index) % 2);
        }

        layoutCopy["yaxis" + (trendCount + 2)] = {
          automargin: true,
          title: groupedName.join(' | '),
          titlefont: { size: 15 },
          range: range,
          title_standoff: 0,
          overlaying: "y",
          position: position,
          side: side
        };
      })
      let resultCount = 0
      const result = []

      Object.values(groupedTrends).forEach((c) => {

        const res = c.map((x, i) => {
          let sample = x.data[0];
          let name = x.telemetry.name;

          const axisIndex = this.trend.trend.findIndex((x) => { if (x.telemetry.name == name && x.data[0].source == sample.source) { return x } })

          name = this.$t('duck.' + name) + " ( " + this.$t('duck.' + sample.source) + ' )';
          let chartModes = {
            lines: "lines",
            "lines+markers": "lines+markers",
            markers: "markers",
            playoutCopyredictions: "markers",
          };
          let serie = {
            x: x.data.map((d) => dayjs(d.createdAt).toDate()),
            y: x.data.map((d) => d.value),
            notes: x.data.map((d) => d.measurement.note),
            name: name,
            type: "scatter",
            mode: chartModes[this.mode],
            yaxis: "y" + (axisIndex + 2),
          };

          if (this.mode == "lines+markers") {
            let widths = x.data.map((a, i) => {
              return a.measurement.note && this.showComments ? 10 : 4;
            });
            serie.line = {
              color: this.colorSet[axisIndex],
            };
            serie.marker = {
              size: widths,
              color: this.colorSet[axisIndex],
              line: {
                width: 0.2,
                color: "black",
              },
            };
          } else if (this.mode == "lines") {
            serie.line = {
              color: this.colorSet[axisIndex],
              width: 3,
            };
          } else if (this.mode == "markers") {
            let widths = x.data.map((a, i) => {
              return a.measurement.note && this.showComments ? 20 : 10;
            });
            serie.marker = {
              size: widths,
              color: this.colorSet[axisIndex],
              line: {
                width: 0,
                color: "black",
              },
            };
          } else if (this.mode == "predictions") {
            let widths = x.data.map((a, i) => {
              return a.measurement.note && this.showComments ? 20 : 10;
            });
            serie.marker = {
              symbol: this.markerSet[axisIndex],
              size: widths,
              line: {
                width: 0.2,
                color: "black",
              },
              opacity: 0.8,
              // color: this.colorSet[i],
              color: x.data.map((d) => {
                let prediction = this.predictions.find(
                  (p) => p.measurement == d.measurement._id
                );
                let colorIndex = 0;
                if (prediction) {
                  colorIndex =
                    Number(prediction.prediction.split("class")[1]) + 1;
                }
                return this.predictionClassColor[colorIndex];
              }),
            };
          }
          resultCount++;
          return serie;
        })
        result.push(...res)
      });

      this.series = [{}, ...result];
      let { shapes, yaxis } = this.prepShapes();
      this.shapes = shapes;
      layoutCopy.shapes = [...shapes];
      layoutCopy.yaxis2 = {
        ...layoutCopy.yaxis2,
        ...yaxis,
      };
      this.plotlyElement = this.$refs.plotly;
      Plotly.newPlot(
        this.$refs.plotly,
        this.series,
        layoutCopy,
        { responsive: true }
      );

      //todo remove selected when new telemetry added
      this.$refs.plotly.on("plotly_click", this.onDataPointClicked);
      this.$refs.plotly.onmousemove = (event) => {
        this.$refs.commentPopup.style.position = "absolute";
        this.$refs.commentPopup.style.left = event.pointerX + 20 + "px";
        this.$refs.commentPopup.style.top = "100px";
      };
      this.$refs.plotly.on("plotly_hover", (d, e) => {
        let measurement =
          this.trend.trend[0].data[d.points[0].pointIndex].measurement;

        if (measurement.note && this.showComments) {
          this.$refs.commentPopup.style.display = "block";
          this.$refs.commentPopup.innerHTML = measurement.note;
        }

        // commentPopup.
        //  console.log(d.points[0].pointIndex)
        //d.points[0].data.marker.color = "rgb(113, 176, 39)";
        // this.currentCurve = d.points[0].curveNumber;
      });
      this.$refs.plotly.on("relayout", (layout) => {

      });
      this.$refs.plotly.on("plotly_unhover", (d) => {
        this.$refs.commentPopup.style.display = "none";

        //let measurement = this.trend.trend[0].data[d.points[0].pointIndex].measurement;
        // this.$refs.commentPopup.$el.style.display = "none";
        //this.$refs.commentPopup.$el.style.top = d.event.clientY+"px"
        // commentPopup.
        //  console.log(d.points[0].pointIndex)
        //d.points[0].data.marker.color = "rgb(113, 176, 39)";
        // this.currentCurve = d.points[0].curveNumber;
      });


    },

    prepShapes() {
      let dataclickedShape = { visible: false };

      if (this.trend.alarm && this.trend.trend.length == 1) {
        let niceMax = Math.max(...this.trend.trend[0].data.map((x) => x.value));
        let niceMin = Math.min(...this.trend.trend[0].data.map((x) => x.value));
        if (this.trend.alarm.thresholdDirection == 1) {
          let max =
            this.trend.alarm.threshold.critical[1] > niceMax
              ? this.trend.alarm.threshold.critical[1]
              : niceMax;
          let min =
            this.trend.alarm.threshold.attention[1] < niceMin
              ? this.trend.alarm.threshold.attention[1]
              : niceMin;
          let gap = niceMax - niceMin;
          let upperRange = max + gap / 2;
          let lowerRange = min - gap / 2;

          return {
            yaxis: {
              range: [niceMin - gap / 2, upperRange],
            },
            shapes: [
              dataclickedShape,
              {
                //#f91414 up
                layer: "below",
                type: "rect",
                xref: "paper",
                x0: 0,
                x1: 1,
                yref: "y",
                opacity: 0.3,
                y0: upperRange,
                y1: this.trend.alarm.threshold.critical[1],
                line: {
                  width: 0,
                },
                fillcolor: "#f91414",
              },
              {
                //#f99314 up
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.critical[1],
                y1: this.trend.alarm.threshold.hazard[1],
                fillcolor: "#f99314",
              },
              {
                //#f9d214 up
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.hazard[1],
                y1: this.trend.alarm.threshold.attention[1],
                fillcolor: "#f9d214",
              },
              {
                //#00ff00
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.attention[1],
                y1: lowerRange,
                fillcolor: "#00ff00",
              },
            ],
          };
        } else if (this.trend.alarm.thresholdDirection == -1) {
          let max =
            this.trend.alarm.threshold.attention[0] > niceMax
              ? this.trend.alarm.threshold.attention[0]
              : niceMax;
          let min =
            this.trend.alarm.threshold.critical[0] < niceMin
              ? this.trend.alarm.threshold.critical[0]
              : niceMin;
          let gap = niceMax - niceMin;
          let upperRange = max + gap / 2;
          let lowerRange = min - gap / 2;
          // this.layout = {
          //
          // };
          return {
            yaxis: {
              range: [niceMin - gap / 2, upperRange],
            },
            shapes: [
              dataclickedShape,
              {
                //#00ff00
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: upperRange,
                y1: this.trend.alarm.threshold.attention[0],
                fillcolor: "#00ff00",
              },

              {
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.attention[0],
                y1: this.trend.alarm.threshold.hazard[0],
                fillcolor: "#f9d214",
              },
              {
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.hazard[0],
                y1: this.trend.alarm.threshold.critical[0],
                fillcolor: "#f99314",
              },
              {
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.critical[0],
                y1: lowerRange,
                fillcolor: "#f91414",
              },
            ],
          };
        } else {
          let max =
            this.trend.alarm.threshold.critical[1] > niceMax
              ? this.trend.alarm.threshold.critical[1]
              : niceMax;
          let min =
            this.trend.alarm.threshold.critical[0] < niceMin
              ? this.trend.alarm.threshold.critical[0]
              : niceMin;
          let gap = niceMax - niceMin;
          let upperRange = max + gap / 2;
          let lowerRange = min - gap / 2;

          return {
            yaxis: {
              range: [niceMin - gap / 2, upperRange],
            },
            shapes: [
              dataclickedShape,
              {
                //#f91414 up
                layer: "below",
                type: "rect",
                xref: "paper",
                x0: 0,
                x1: 1,
                yref: "y",
                opacity: 0.3,
                y1: upperRange,
                y0: this.trend.alarm.threshold.critical[1],
                line: {
                  width: 0,
                },
                fillcolor: "#f91414",
              },
              {
                //#f99314 up
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.critical[1],
                y1: this.trend.alarm.threshold.hazard[1],
                fillcolor: "#f99314",
              },
              {
                //#f9d214 up
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.hazard[1],
                y1: this.trend.alarm.threshold.attention[1],
                fillcolor: "#f9d214",
              },
              {
                //#00ff00
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.attention[1],
                y1: this.trend.alarm.threshold.attention[0],
                fillcolor: "#00ff00",
              },

              {
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.attention[0],
                y1: this.trend.alarm.threshold.hazard[0],
                fillcolor: "#f9d214",
              },
              {
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.hazard[0],
                y1: this.trend.alarm.threshold.critical[0],
                fillcolor: "#f99314",
              },
              {
                layer: "below",
                type: "rect",
                xref: "paper",
                yref: "y",
                x0: 0,
                x1: 1,
                opacity: 0.3,
                line: {
                  width: 0,
                },
                y0: this.trend.alarm.threshold.critical[0],
                y1: lowerRange,
                fillcolor: "#f91414",
              },
            ],
          };
        }
      } else {
        return {
          yaxis: {},
          shapes: [dataclickedShape],
        };
      }
    },
  },
};
</script>
<style>
.beta-badge {
  font-size: 3px;
}
</style>